import { computed, inject, Injectable, Signal } from '@angular/core';
import { Config } from '../models/config.interface';
import { DOMAIN_CONFIG } from '../tokens/domain-config.token';
import { ENVIRONMENT } from '../tokens/environment.token';
import { RUNTIME_CONFIG } from '../tokens/runtime-config.token';
import { mergeObject } from '../utils/config/config.utils';

@Injectable({ providedIn: 'root' })
export class ConfigService<T extends Config = Config> {
  private readonly domainConfig = inject<Partial<T>>(DOMAIN_CONFIG);
  private readonly environment = inject<Partial<T>>(ENVIRONMENT);
  private readonly runtimeConfig = inject<Partial<T>>(RUNTIME_CONFIG);

  private readonly config: Signal<Config> = computed<Config>(() => {
    const merged = mergeObject<Config>(
      this.domainConfig,
      this.environment,
      this.runtimeConfig,
    );

    return {
      ...merged,
      features: {
        ...this.environment.buildFeatures,
        ...this.domainConfig.domainFeatures,
      },
    };
  });

  getConfig(): Config {
    return this.config();
  }
}
